const ContentBlockItem = ({
  image,
  title,
}: {
  image?: string;
  title?: string;
}) => {
  return (
    <div className="content-block__block">
      <div className="content-block__icon">
        <img src={image} alt={title} />
      </div>
      <div className="content-block__text">{title}</div>
    </div>
  );
};

export default ContentBlockItem;
